module.exports = __webpack_public_path__ + "static/media/manual.550a3830.pdf";